import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@unite-us/ui';
import { theme } from '../../../../tailwind.config';
var BulletIndicator = function BulletIndicator(_ref) {
  var isChecked = _ref.isChecked;
  return isChecked ? /*#__PURE__*/React.createElement("span", {
    role: "checkbox",
    "aria-checked": "true",
    className: "inline-block mr-2 -mt-1 h-4"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "V2CheckCircle",
    color: theme.extend.colors['brand-blue']
  })) : /*#__PURE__*/React.createElement("span", {
    role: "checkbox",
    "aria-checked": "false",
    className: "inline-block mr-2 rounded-full h-4 w-4 bg-border-grey"
  });
};
BulletIndicator.propTypes = {
  isChecked: PropTypes.bool.isRequired
};
var PlanRequirementsDisplay = function PlanRequirementsDisplay(_ref2) {
  var clientHasConsent = _ref2.clientHasConsent,
    isSamePayer = _ref2.isSamePayer;
  return /*#__PURE__*/React.createElement("div", {
    className: "space-y-2 py-2"
  }, /*#__PURE__*/React.createElement("p", {
    className: "pb-2"
  }, "This plan has requirements for enrollment and must be approved by the plan administrator:"), !isSamePayer && /*#__PURE__*/React.createElement("p", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement(BulletIndicator, {
    isChecked: clientHasConsent
  }), "Client must provide informed consent to be on the Unite Us platform"));
};
PlanRequirementsDisplay.propTypes = {
  clientHasConsent: PropTypes.bool,
  isSamePayer: PropTypes.bool
};
PlanRequirementsDisplay.defaultProps = {
  clientHasConsent: false,
  isSamePayer: false
};
export default PlanRequirementsDisplay;
//# sourceMappingURL=PlanRequirementsDisplay.js.map